import KLink from "./KLink";
import { formatPhone } from "kinnect-formatters";

export default {
	name: "KPhoneLink",

	props: {
		phone: [ Number, String ],
		icon: {
			default: "phone",
			type: String
		}
	},

	render() {
		return <KLink
			href={`tel:+${this.phone}`}
			icon={this.icon}
		>
			{formatPhone( this.phone )}
		</KLink>;
	}
};
